import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'
import { useBreakpointValue } from '@chakra-ui/react'

const parts = ['container', 'header', 'body', 'footer']

const baseStyle = {
    container: {
        borderRadius: '0.5rem',
    },
    header: {
        padding: '1rem 2rem',
    },
    body: {
        padding: '3rem 2rem 2rem 2rem',
    },
    footer: {
        padding: '1rem 2rem'
    }
}

const variants = {
    primary: (props: StyleFunctionProps) => ({
        container: {
            backgroundColor: mode('white', '#414141')(props),
            boxShadow: mode('rgba(100,100,111,0.2) 0px 7px 29px 0px', 'rgba(0,0,0,0.2) 2px 5px 15px 4px ')(props),
        },
        header: {
            backgroundColor: 'brand1.400',
            position: 'absolute',
            top: '-2rem',
            maxWidth: 'fit-content',
            margin: '0 auto 0',
            borderRadius: '0.5rem 0.5rem 0.5rem 0',
        },
        body: {
            padding: useBreakpointValue({ base: '3rem 1rem 1rem 1rem', sm: '3rem 1.5rem 1.5rem 1.5rem' }),
        },
        footer: {
            alignSelf: 'center',
        }
    }),
    secondary: (props: StyleFunctionProps) => ({
        container: {
            backgroundColor: mode('white', '#414141')(props),
            boxShadow: mode('rgba(100,100,111,0.2) 0px 7px 29px 0px', 'rgba(0,0,0,0.2) 2px 5px 15px 4px ')(props),
        },
        header: {
            position: 'relative',
            width: '100%', 
            minHeight: '1.25rem', 
            margin: '0 auto',
            padding: '24px 0',
            backgroundColor: 'brand1.400',
            borderRadius: '0.5rem 0.5rem 0 0',
            boxShadow: mode('rgba(100,100,111,0.2) 0px 7px 29px 0px', 'rgba(0,0,0,0.2) 2px 5px 15px 4px ')(props),
        },
        body: {
            padding: useBreakpointValue({ base: '1rem', sm: '1.5rem' }),
        },
        footer: {
            padding: '1.5rem',
            alignSelf: 'center',
        }
    }),
}

export const Card = {
    parts,
    baseStyle,
    variants,
}
